import { render, staticRenderFns } from "./yindao.vue?vue&type=template&id=0dab3cd1&scoped=true&"
import script from "./yindao.vue?vue&type=script&lang=js&"
export * from "./yindao.vue?vue&type=script&lang=js&"
import style0 from "./yindao.vue?vue&type=style&index=0&id=0dab3cd1&lang=scss&scoped=true&"
import style1 from "./yindao.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dab3cd1",
  null
  
)

export default component.exports